export const publicData = {
  // footer 页面数据 - 联系我们列表
  contactList: [
    { label: "电话：", value: "0551-65365025" },
    { label: "邮箱：", value: "hr@duodianmeihao.com" },
    {
      label: "商务合作：",
      value: "bd@duodianmeihao.com",
    },
    {
      label: "地址：",
      value: "安徽省合肥市高新区创新大道2800号创新产业园二期G3",
    },
  ],
  // about 页面数据 - 多美生活列表（pc + mobile）
  lifeList: [
    {
      name: "tab1",
      title: "做有挑战的事",
      iconClass: "orange",
      bgClass: "orange-bg",
      desc: "在有挑战的项目中，获得多元化的成长和发展",
      imageSrc: require("@/assets/imgs/pc/about-life-img1.webp"),
      icon: require("@/assets/imgs/pc/about-life-tabIcon1.png"),
      iconActive: require("@/assets/imgs/common/about-life-tabIcon1-active.png"),
      mobileImgUrl: require("@/assets/imgs/mobile/about-life-img1.webp"),
    },
    {
      name: "tab2",
      title: "重视优秀人才",
      iconClass: "blue",
      bgClass: "blue-bg",
      desc: "打造全周期成长平台，赋能人才价值最大化",
      imageSrc: require("@/assets/imgs/pc/about-life-img2.webp"),
      icon: require("@/assets/imgs/pc/about-life-tabIcon2.png"),
      iconActive: require("@/assets/imgs/common/about-life-tabIcon2-active.png"),
      mobileImgUrl: require("@/assets/imgs/mobile/about-life-img2.webp"),
    },
    {
      name: "tab3",
      title: "激励和回报",
      iconClass: "green",
      bgClass: "green-bg",
      desc: "加大激励区分度，让优秀者得到认可与回报",
      imageSrc: require("@/assets/imgs/pc/about-life-img3.webp"),
      icon: require("@/assets/imgs/pc/about-life-tabIcon3.png"),
      iconActive: require("@/assets/imgs/common/about-life-tabIcon3-active.png"),
      mobileImgUrl: require("@/assets/imgs/mobile/about-life-img3.webp"),
    },
    {
      name: "tab4",
      title: "学习和培养",
      iconClass: "yellow",
      bgClass: "yellow-bg",
      desc: "开放丰富的学习培养资源，持续积累提升",
      imageSrc: require("@/assets/imgs/pc/about-life-img4.webp"),
      icon: require("@/assets/imgs/pc/about-life-tabIcon4.png"),
      iconActive: require("@/assets/imgs/common/about-life-tabIcon4-active.png"),
      mobileImgUrl: require("@/assets/imgs/mobile/about-life-img4.webp"),
    },
    {
      name: "tab5",
      title: "务实平等工作氛围",
      iconClass: "purple",
      bgClass: "purple-bg",
      desc: "不讲“Tittle”，关注实际效果",
      imageSrc: require("@/assets/imgs/pc/about-life-img5.webp"),
      icon: require("@/assets/imgs/pc/about-life-tabIcon5.png"),
      iconActive: require("@/assets/imgs/common/about-life-tabIcon5-active.png"),
      mobileImgUrl: require("@/assets/imgs/mobile/about-life-img5.webp"),
    },
  ],
  // growthCare 页面数据 - 人才发展列表（pc + mobile）
  tabsList: [
    {
      name: "first",
      label: "新人成长",
      imgUrl: require("@/assets/imgs/pc/growthCare-tab-img1.webp"),
      mobileImgUrl: require("@/assets/imgs/mobile/growthCare-tab-img1.webp"),
      tabTextList: [
        {
          tit1: "新人星计划",
          desc1: "帮助新员工快速了解公司文化、规章制度和团队，更快Landing",
        },
        {
          tit1: "导师带教",
          desc1: "提供一对一指导，帮助新员工解决实际问题，加速成长",
        },
        {
          tit1: "岗位技能培训",
          desc1: "针对岗位所需的专业技能进行培训（如编程、设计、市场技巧等）",
        },
      ],
    },
    {
      name: "second",
      label: "专业提升",
      imgUrl: require("@/assets/imgs/pc/growthCare-tab-img2.webp"),
      mobileImgUrl: require("@/assets/imgs/mobile/growthCare-tab-img2.webp"),
      tabTextList: [
        {
          tit1: "多美学堂",
          desc1: "通过培训学习和知识分享，提升员工的专业能力",
        },
        {
          tit1: "经验分享",
          desc1: "通过优秀经验与方法论分享交流，激发创新思维",
        },
        {
          tit1: "学习百万计划",
          desc1:
            "通过引进专家培训、在线付费课程学习、考证提升等多元化学习方式，系统性赋能员工提升",
        },
      ],
    },
    {
      name: "third",
      label: "管理提升",
      imgUrl: require("@/assets/imgs/pc/growthCare-tab-img3.webp"),
      mobileImgUrl: require("@/assets/imgs/mobile/growthCare-tab-img3.webp"),
      tabTextList: [
        {
          tit1: "启航计划",
          desc1: "赋能新晋管理，结合内/外训，加速成长，提升管理技能",
        },
        {
          tit1: "领航计划",
          desc1: "赋能管理者，通过实战场景演练与走出去学习进修，提升领导力",
        },
      ],
    },
    {
      name: "fourth",
      label: "领导力发展",
      imgUrl: require("@/assets/imgs/pc/growthCare-tab-img4.webp"),
      mobileImgUrl: require("@/assets/imgs/mobile/growthCare-tab-img4.webp"),
      tabTextList: [
        { tit1: "赋能高管/专家，走出去跨界交流，开拓战略视野" },
        { tit1: "MBA赋能计划，驱动商业决策" },
      ],
    },
  ],
  // growthCare 页面数据 - 福利体系列表（pc + mobile）
  employeeBenefitsList: [
    {
      tit: "家庭温度 · 陪伴无缺",
      li1: "带薪年假",
      li2: "育儿假",
      li3: "产检假",
      icon: require("@/assets/imgs/common/growthCare-employeeBenefitsIcon.png"),
      mobileSwipeList: [
        {
          imgUrl: require("@/assets/imgs/common/growthCare-benefits-card1-imgUrl1.webp"),
        },
        {
          imgUrl: require("@/assets/imgs/common/growthCare-benefits-card1-imgUrl2.webp"),
        },
      ],
    },
    {
      tit: "团建凝聚 · 快乐加倍",
      li1: "月度团建",
      li2: "定期拓展",
      li3: "年度旅游",
      icon: require("@/assets/imgs/common/growthCare-employeeBenefitsIcon.png"),
      mobileSwipeList: [
        {
          imgUrl: require("@/assets/imgs/common/growthCare-benefits-card2-imgUrl1.webp"),
        },
        {
          imgUrl: require("@/assets/imgs/common/growthCare-benefits-card2-imgUrl2.webp"),
        },
      ],
    },
    {
      tit: "能力补给 · 轻装上阵",
      li1: "餐补",
      li2: "免费下午茶",
      li3: "丰富夜宵",
      icon: require("@/assets/imgs/common/growthCare-employeeBenefitsIcon.png"),
      mobileSwipeList: [
        {
          imgUrl: require("@/assets/imgs/common/growthCare-benefits-card3-imgUrl1.webp"),
        },
        {
          imgUrl: require("@/assets/imgs/common/growthCare-benefits-card3-imgUrl2.webp"),
        },
      ],
    },
    {
      tit: "健康关怀 · 身心在线",
      li1: "年度健康体检",
      li2: "免费健身房",
      li3: "篮球/羽毛球/网球社团",
      icon: require("@/assets/imgs/common/growthCare-employeeBenefitsIcon.png"),
      mobileSwipeList: [
        {
          imgUrl: require("@/assets/imgs/common/growthCare-benefits-card4-imgUrl1.webp"),
        },
        {
          imgUrl: require("@/assets/imgs/common/growthCare-benefits-card4-imgUrl2.webp"),
        },
      ],
    },
  ],
  // companyCulture 页面数据 - 多美使命列表（mobile）
  missionList: [
    {
      icon: require("@/assets/imgs/common/companyCulture-mission-icon1.webp"),
      text: "为用户，提供优秀的产品和服务",
    },
    {
      icon: require("@/assets/imgs/common/companyCulture-mission-icon2.webp"),
      text: "为员工，营造快乐进取氛围、搭建价值成就平台",
    },
    {
      icon: require("@/assets/imgs/common/companyCulture-mission-icon3.webp"),
      text: "为合作伙伴，建立互信共赢的合作生态，为客户提供价值",
    },
    {
      icon: require("@/assets/imgs/common/companyCulture-mission-icon4.webp"),
      text: "为股东/期权，提供长期稳健的回报",
    },
  ],
  // companyCulture 页面数据 - 多美价值观列表（pc + mobile）
  valuesList: [
    {
      culturalValuesImg: require("@/assets/imgs/pc/companyCulture-values-img1.png"),
      mobileValuesBgUrl: require("@/assets/imgs/mobile/companyCulture-values-item-Bg1.webp"),
      tit: "用户导向",
      li1: "IAA产品对用户有价值，IAP产品物有所值",
      li2: "以用户需求为中心，避免想当然和自我感动",
      li3: "解决用户问题，围绕用户持续改进与创新",
    },
    {
      culturalValuesImg: require("@/assets/imgs/pc/companyCulture-values-img2.png"),
      mobileValuesBgUrl: require("@/assets/imgs/mobile/companyCulture-values-item-Bg2.webp"),
      tit: "创新进取",
      li1: "不自嗨，有进取心，不断追求进步",
      li2: "敢于质疑，勇于创新，不断验证，寻求突破",
      li3: "打破思维定势，不断寻求新的增长",
    },
    {
      culturalValuesImg: require("@/assets/imgs/pc/companyCulture-values-img3.png"),
      mobileValuesBgUrl: require("@/assets/imgs/mobile/companyCulture-values-item-Bg3.webp"),
      tit: "始终创业",
      li1: "保持创业心态，激情、奋斗、投入",
      li2: "持续思考目标与路径，系统规划，谋求发展",
      li3: "快、高效，保持敏捷和危机意识，始终开创而不守成",
    },
    {
      culturalValuesImg: require("@/assets/imgs/pc/companyCulture-values-img4.png"),
      mobileValuesBgUrl: require("@/assets/imgs/mobile/companyCulture-values-item-Bg4.webp"),
      tit: "积极主动",
      li1: "主动承担，跨前一步解决问题",
      li2: "持续自驱，自我设定挑战目标",
      li3: "前瞻预判，提前规划应对变化",
    },
    {
      culturalValuesImg: require("@/assets/imgs/pc/companyCulture-values-img5.png"),
      mobileValuesBgUrl: require("@/assets/imgs/mobile/companyCulture-values-item-Bg5.webp"),
      tit: "专业务实",
      li1: "专业敬业，高标准，避免低级错误，追求卓越",
      li2: "直接体验，深入事实，拿一手数据或信息，用数据说话",
      li3: "就事论事，理性沟通，准确表达，避免主观臆测和情绪化表达",
    },
    {
      culturalValuesImg: require("@/assets/imgs/pc/companyCulture-values-img6.png"),
      mobileValuesBgUrl: require("@/assets/imgs/mobile/companyCulture-values-item-Bg6.webp"),
      tit: "成长共赢",
      li1: "持续学习，不设边界，不断学习优秀",
      li2: "简单真诚，协作共赢，共同解决问题",
      li3: "开放交流，乐于分享，与组织共同成长",
    },
  ],
  // companyCulture 页面数据 - 多美文化生活列表（pc + mobile）
  culturalLifeList: [
    {
      url: require("@/assets/imgs/common/companyCulture-culturalLifeIcon1.png"),
      swiperUrl: require("@/assets/imgs/pc/companyCulture-culturalLifeImg1.webp"),
      mobileSwiperUrl: require("@/assets/imgs/mobile/companyCulture-culturalLifeImg1.webp"),
      tit: "温暖有爱的员工活动",
      desc: "月度生日派对、主题团建、1024程序员节、端午中秋节活动，传递公司对员工的情感关怀",
    },
    {
      url: require("@/assets/imgs/common/companyCulture-culturalLifeIcon2.png"),
      swiperUrl: require("@/assets/imgs/pc/companyCulture-culturalLifeImg2.webp"),
      mobileSwiperUrl: require("@/assets/imgs/mobile/companyCulture-culturalLifeImg2.webp"),
      tit: "活力迸发的兴趣俱乐部",
      desc: "篮球、羽毛球、读书会等兴趣俱乐部，为热爱提供绽放舞台",
    },
    {
      url: require("@/assets/imgs/common/companyCulture-culturalLifeIcon3.png"),
      swiperUrl: require("@/assets/imgs/pc/companyCulture-culturalLifeImg3.webp"),
      mobileSwiperUrl: require("@/assets/imgs/mobile/companyCulture-culturalLifeImg3.webp"),
      tit: "榜样引领的荣誉激励体系",
      desc: "通过颁奖礼表彰优秀员工，连载榜样人物故事，打造可感知的职场进阶标杆",
    },
    {
      url: require("@/assets/imgs/common/companyCulture-culturalLifeIcon4.png"),
      swiperUrl: require("@/assets/imgs/pc/companyCulture-culturalLifeImg4.webp"),
      mobileSwiperUrl: require("@/assets/imgs/mobile/companyCulture-culturalLifeImg4.webp"),
      tit: "开放多元的文化交流平台",
      desc: "定期开展公司面对面，CEO小饭桌，零距离感受团队文化与工作氛围",
    },
  ],
};
